/**
 * Provider for "platform" key
 * @module
 */
module.exports = {
  provides: 'platform',
  isSticky: true,

  getter: [
    'sources/platform',
    function(PlatformSource) {
      return PlatformSource.getPlatform();
    },
  ],
};
